import { render, staticRenderFns } from "./modifySchemaDrawer.vue?vue&type=template&id=0f4c983f"
import script from "./modifySchemaDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./modifySchemaDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./modifySchemaDrawer.vue?vue&type=style&index=0&id=0f4c983f&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports